import axios from 'axios';

export const getMyTeamMemberships = payload => axios.get('/api/me/team/memberships', payload);

export const calculateProrateAmount = payload => axios.post('/api/me/team/calculate-prorate-amount', payload);

export const getMyTeam = () => axios.get('/api/me/team');

export const inviteMemberToMyTeam = payload => axios.put('/api/me/team/invite', payload);

export const updateTeamSeats = payload => axios.post('/api/me/team/update-seats', payload);
